import { ReactElement, useCallback } from 'react';

import { ActionBar, ButtonVariant, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { calendarTranslationKeys, visitTranslationKeys } from '../../translations';

export const GoToWaitlistAction = (): ReactElement => {
   const push = useHistoryPushWithBackAction(false);
   const handleClick = useCallback(() => {
      push(visitPaths.CALENDAR_WAITLIST_PATH, { label: visitTranslationKeys.goBackToAppointmentsList });
   }, [push]);
   return (
      <ActionBar.PrimaryButton
         testId={'goToWaitlist'}
         label={calendarTranslationKeys.waitlist}
         onClick={handleClick}
         variant={ButtonVariant.PRIMARY}
         blockingOperation
      />
   );
};
